// this function checks if end of node is reached
const isEndOfNode = (editor) => {
  const { fragment } = editor.value;
  const { selection: initialSelection } = editor.value;
  const { focus } = initialSelection;
  const { key: focusKeyBefore } = focus;
  const lengthBefore = fragment.text.length;
  editor.moveFocusForward(1);
  const { selection: selectionAfter, fragment: fragmentAfter } = editor.value;
  const { focus: focusAfter } = selectionAfter;
  let end = false;
  const { key: focusKeyAfter } = focusAfter;
  if (focusKeyBefore !== focusKeyAfter) {
    end = true;
  }
  // for extreme end of paragraph
  if (
    fragmentAfter.text.length === lengthBefore &&
    focusKeyBefore === focusKeyAfter
  ) {
    end = true;
  }
  editor.select(initialSelection);
  return end;
};

export default isEndOfNode;
